import { atom } from "jotai";
import { atomFamily } from "jotai/utils";
import { Interface, InterfaceFetchResult } from "../types";
import {
  extractErrorMessageFromResponse,
  isTemplateInterfaceProjectId,
} from "../utils";

export const fetchInterfaceProjectAtomFamily_SUSPENDS = atomFamily(
  (interfaceProjectId: string | undefined) => {
    const baseAtom = atom(
      async (): Promise<InterfaceFetchResult | null | undefined> => {
        /* ---------- skip fetch when no id or a template placeholder ---------- */
        if (!interfaceProjectId) {
          return;
        }
        if (isTemplateInterfaceProjectId(interfaceProjectId)) {
          // Because we don't want to fetch template asset id and get a 404 Not Found error
          return;
        }

        try {
          const res = await fetch(
            `/api/canvasui/interfaces/${interfaceProjectId}`,
          );

          /* ---------- success ---------- */
          if (res.ok) {
            const data = (await res.json()) as Interface;
            return { type: "success", data };
          }

          /* ---------- expected errors surfaced to UI ---------- */
          if (res.status === 404) {
            return { type: "not_found" };
          }
          if (res.status === 403) {
            return { type: "forbidden" };
          }

          /* ---------- 5xx or other unexpected errors – log & degrade ---------- */
          const errorMessage = await extractErrorMessageFromResponse(res);
          console.error(
            `Failed to fetch interface project ${interfaceProjectId}: ${errorMessage}`,
          );
          return null;
        } catch (error) {
          console.error("Network error fetching interface project:", error);
          // Network / unknown error – degrade to null
          return null;
        }
      },
    );

    baseAtom.debugLabel = `fetchInterfaceProjectAtomFamily_SUSPENDS(${interfaceProjectId})`;
    return baseAtom;
  },
);
